import { render, staticRenderFns } from "./SlideDownAnimation.vue?vue&type=template&id=66d52264&scoped=true&"
import script from "./SlideDownAnimation.vue?vue&type=script&lang=js&"
export * from "./SlideDownAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d52264",
  null
  
)

export default component.exports